// Conteúdos/artigos da Maternnia — estrutura preparada para CMS (Etapa 8). Dados de exemplo.
export const ARTIGO_ETAPAS = ["Planejamento", "Gestação", "Parto", "Pós-parto"];
export const ARTIGO_CATEGORIAS = [
  "Nutrição", "Fertilidade", "Pré-natal", "Saúde emocional", "Plano de parto",
  "Doulas", "Amamentação", "Pediatria",
];

const U = (id, p) => `https://images.unsplash.com/photo-${id}?w=${p || 900}&q=80&auto=format&fit=crop`;
const GEN = (h) => `https://static.prod-images.emergentagent.com/jobs/424cc6d9-f0bf-4897-9d6b-2170e84bc4d8/images/${h}.png`;

const buildBody = (titulo, etapa) => [
  { type: "paragraph", text: `${titulo} é um tema importante na etapa de ${etapa.toLowerCase()}. Reunimos aqui orientações claras para ajudar você a entender o assunto e tomar decisões com mais tranquilidade, sempre com o apoio de profissionais de confiança.` },
  { type: "heading", text: "Por onde começar" },
  { type: "paragraph", text: "Antes de qualquer decisão, vale organizar suas dúvidas e conversar com um profissional de referência. Cada jornada é única, e o que funciona para uma família pode não ser ideal para outra." },
  { type: "list", items: [
    "Anote suas principais dúvidas e prioridades.",
    "Busque fontes confiáveis e atualizadas.",
    "Considere o acompanhamento de um profissional especializado.",
  ] },
  { type: "heading", text: "O que considerar" },
  { type: "paragraph", text: "Avalie seu momento, sua rotina e sua rede de apoio. Informação de qualidade reduz a ansiedade e ajuda você a se sentir no controle das próprias escolhas ao longo da jornada." },
  { type: "paragraph", text: "Lembre-se: este conteúdo é educativo e não substitui a avaliação individual de um profissional de saúde." },
];

const REFS = [
  "Ministério da Saúde — Caderneta da Gestante.",
  "Organização Mundial da Saúde (OMS) — Recomendações de cuidado materno.",
  "Sociedade Brasileira de Pediatria — Orientações para famílias.",
];

export const ARTIGOS = [
  {
    id: "art-1", slug: "como-comecar-a-planejar-uma-gravidez",
    titulo: "Como começar a planejar uma gravidez",
    resumo: "Os primeiros passos para se preparar com calma antes de tentar engravidar.",
    etapa: "Planejamento", categoria: "Fertilidade",
    autor: "Equipe Maternnia", revisor: "Dra. Helena Prado (Obstetra)",
    data: "2026-05-12", tempoLeitura: "6 min", destaque: true,
    imagem: U("1668605335558-a13236f088e3"), imagemAlt: "Pessoa de costas pesquisando e anotando",
    profissionais: ["p8", "p1"],
  },
  {
    id: "art-2", slug: "alimentacao-pre-concepcional",
    titulo: "Alimentação pré-concepcional: o que priorizar",
    resumo: "Como a nutrição pode preparar o corpo para uma gestação saudável.",
    etapa: "Planejamento", categoria: "Nutrição",
    autor: "Equipe Maternnia", revisor: "Espaço Nutrir (Nutrição)",
    data: "2026-05-03", tempoLeitura: "5 min", destaque: false,
    imagem: U("1490474418585-ba9bad8fd0ea"), imagemAlt: "Frutas frescas sobre tecido branco",
    profissionais: ["p3", "p11"],
  },
  {
    id: "art-3", slug: "o-que-esperar-no-primeiro-trimestre",
    titulo: "O que esperar no primeiro trimestre",
    resumo: "Sintomas comuns, primeiros exames e cuidados no início da gestação.",
    etapa: "Gestação", categoria: "Pré-natal",
    autor: "Equipe Maternnia", revisor: "Dra. Beatriz Nunes (Obstetra)",
    data: "2026-04-22", tempoLeitura: "7 min", destaque: true,
    imagem: U("1493894473891-10fc1e5dbd22"), imagemAlt: "Mãos sobre a barriga de gestante",
    profissionais: ["p1", "p9"],
  },
  {
    id: "art-4", slug: "saude-emocional-na-gestacao",
    titulo: "Saúde emocional na gestação",
    resumo: "Como cuidar das emoções e buscar apoio durante a gravidez.",
    etapa: "Gestação", categoria: "Saúde emocional",
    autor: "Equipe Maternnia", revisor: "Instituto Equilíbrio (Psicologia perinatal)",
    data: "2026-04-15", tempoLeitura: "6 min", destaque: false,
    imagem: U("1599008634438-fc6d2be54835"), imagemAlt: "Caderno e café, momento de calma",
    profissionais: ["p6"],
  },
  {
    id: "art-5", slug: "nutricao-na-gravidez",
    titulo: "Nutrição na gravidez: mitos e verdades",
    resumo: "Esclarecendo dúvidas comuns sobre alimentação durante a gestação.",
    etapa: "Gestação", categoria: "Nutrição",
    autor: "Equipe Maternnia", revisor: "NutriMaterna (Nutrição)",
    data: "2026-04-08", tempoLeitura: "6 min", destaque: false,
    imagem: GEN("8d824a0405e7368852a125db122bee3666c4c82a2b40b4c0284606a6fb6f943a"), imagemAlt: "Gestante com as mãos em coração sobre a barriga",
    profissionais: ["p3", "p11"],
  },
  {
    id: "art-6", slug: "como-montar-seu-plano-de-parto",
    titulo: "Como montar seu plano de parto",
    resumo: "Um guia prático para registrar suas preferências para o nascimento.",
    etapa: "Parto", categoria: "Plano de parto",
    autor: "Equipe Maternnia", revisor: "Maternidade Acolher",
    data: "2026-03-30", tempoLeitura: "8 min", destaque: true,
    imagem: "https://images.pexels.com/photos/3958952/pexels-photo-3958952.jpeg?auto=compress&cs=tinysrgb&w=900", imagemAlt: "Quarto de bebê acolhedor em tons neutros de bege e verde",
    profissionais: ["p2", "p10"],
  },
  {
    id: "art-7", slug: "doula-o-que-faz-e-quando-contratar",
    titulo: "Doula: o que faz e quando contratar",
    resumo: "Entenda o papel da doula e como esse apoio pode ajudar você.",
    etapa: "Parto", categoria: "Doulas",
    autor: "Equipe Maternnia", revisor: null,
    data: "2026-03-21", tempoLeitura: "5 min", destaque: false,
    imagem: "https://customer-assets.emergentagent.com/job_pregnancy-platform/artifacts/zmire97u_file_00000000443471f4a54041f5a3a315c8.png", imagemAlt: "Mãe oriental sendo amparada ao chegar à maternidade", imgPortrait: true,
    profissionais: ["p2", "p10"],
  },
  {
    id: "art-8", slug: "amamentacao-primeiros-dias-com-apoio",
    titulo: "Amamentação: primeiros dias com apoio",
    resumo: "Dicas para os primeiros dias de amamentação, com acolhimento e sem culpa.",
    etapa: "Pós-parto", categoria: "Amamentação",
    autor: "Equipe Maternnia", revisor: "Camila Ferraz (Consultora de amamentação)",
    data: "2026-03-10", tempoLeitura: "6 min", destaque: true,
    imagem: GEN("c12426409063711673535887afe4fea52b244d8a494bc8e3bfaafeb5e6e75b5f"), imagemAlt: "Pezinhos de bebê pardo acolhidos pelas mãos de um adulto",
    profissionais: ["p5", "p4"],
  },
  {
    id: "art-9", slug: "como-escolher-um-pediatra",
    titulo: "Como escolher um pediatra antes do nascimento",
    resumo: "O que avaliar para escolher o pediatra do seu bebê com tranquilidade.",
    etapa: "Pós-parto", categoria: "Pediatria",
    autor: "Equipe Maternnia", revisor: "Dr. Rafael Antunes (Pediatra)",
    data: "2026-03-02", tempoLeitura: "5 min", destaque: false,
    imagem: U("1611417041461-2060f649193d"), imagemAlt: "Mão de adulto segurando a mãozinha de um bebê",
    profissionais: ["p4", "p12"],
  },
].map((a) => ({ ...a, body: buildBody(a.titulo, a.etapa), referencias: REFS }));

export const getArtigo = (slug) => ARTIGOS.find((a) => a.slug === slug);

export const getRelacionados = (artigo, max = 3) =>
  ARTIGOS.filter((a) => a.slug !== artigo.slug && a.etapa === artigo.etapa).slice(0, max);

export const formatarData = (iso) =>
  new Date(iso + "T00:00:00").toLocaleDateString("pt-BR", { day: "2-digit", month: "long", year: "numeric" });

export const ETAPA_GRADIENTE = {
  Planejamento: "from-maternnia-gold/25 to-maternnia-gold/5 text-maternnia-gold",
  Gestação: "from-maternnia-pink/25 to-maternnia-pink/5 text-maternnia-pink",
  Parto: "from-maternnia-eucalipto/25 to-maternnia-eucalipto/5 text-maternnia-eucalipto",
  "Pós-parto": "from-maternnia-taupe/25 to-maternnia-taupe/5 text-maternnia-taupe",
};
